import { ButtonGroup, DropdownButton } from "@/components/ui/button";
import { Menu, MenuItem, MenuPopover, MenuTrigger } from "@/components/ui/menu";
import { cn } from "@/lib/utils";
import { CheckIcon } from "@phosphor-icons/react";
import type { FeedVolumeGraphHeaderProps } from "./NewsFeedVolumeGraph.types";
import {
  getChartStackedByOptions,
  normalizeStackByToOldFormat,
} from "./feedVolumeGraphHelpers";

const NewsFeedVolumeGraphHeader = ({
  period,
  setPeriod,
  resetView,
  stackFeedVolumeBy,
  setStackFeedVolumeBy,
}: FeedVolumeGraphHeaderProps) => {
  // button configurations
  const buttonConfig = [
    {
      label: "Day",
      onClick: () => {
        setPeriod("day");
        resetView();
      },
    },
    {
      label: "Week",
      onClick: () => {
        setPeriod("week");
        resetView();
      },
    },
    {
      label: "Month",
      onClick: () => {
        setPeriod("month");
        resetView();
      },
    },
  ];

  const getDefaultSelectedIndex = () => {
    if (period === "day") return 0;
    if (period === "week") return 1;
    if (period === "month") return 2;
    return 2;
  };

  const chartStackedByOptions = getChartStackedByOptions();
  // Normalize stackFeedVolumeBy to old format for comparison (handles both enum and old format)
  const normalizedStackBy =
    normalizeStackByToOldFormat(stackFeedVolumeBy) ?? stackFeedVolumeBy;
  const selectedStackByOption = chartStackedByOptions.find(
    (option) => option.value === normalizedStackBy,
  );

  return (
    <div className={"flex justify-end"}>
      <MenuTrigger>
        <DropdownButton
          ariaLabel={"Stack Charts By"}
          label={selectedStackByOption?.label || "All"}
          trailingIcon={selectedStackByOption?.icon}
          dropdownVariant={"secondary"}
        />
        <MenuPopover crossOffset={-12}>
          <Menu className={"bg-white w-[212px]"}>
            <MenuItem
              className={cn(
                "text-xs px-3.5 py-2.5",
                selectedStackByOption?.value === null && "font-semibold",
              )}
              onAction={() => {
                setStackFeedVolumeBy(null);
                resetView();
              }}
            >
              All categories
              {selectedStackByOption?.value === null && (
                <CheckIcon className={"w-4 h-4 ml-auto"} />
              )}
            </MenuItem>
            <MenuItem
              isDisabled={true}
              className={
                "text-[10px] font-semibold border-t-[1.5px] rounded-none px-3.5 pt-3"
              }
            >
              Compare by
            </MenuItem>
            {chartStackedByOptions.slice(1).map((option) => (
              <MenuItem
                className={cn(
                  "text-xs px-3.5 py-2.5",
                  selectedStackByOption?.value === option.value &&
                    "font-semibold",
                )}
                key={option.value}
                onAction={() => {
                  setStackFeedVolumeBy(option.value);
                  resetView();
                }}
              >
                {option.label}
                {option.icon ?? option.icon}
                {selectedStackByOption?.value === option.value && (
                  <CheckIcon className={"w-4 h-4 ml-auto"} />
                )}
              </MenuItem>
            ))}
          </Menu>
        </MenuPopover>
      </MenuTrigger>
      <ButtonGroup
        buttonConfig={buttonConfig}
        className={"ml-3"}
        defaultSelectedIndex={getDefaultSelectedIndex()}
      />
    </div>
  );
};

export default NewsFeedVolumeGraphHeader;
